import React, { Component } from 'react'
import './ProgressBar.css'

class ProgressBar extends Component {
    render() {
        const style = {}
        style.width = this.props.size + '%'
        return (
            <div className="ProgressBar">
                <div className="time semibold-font"> {this.props.time} min</div>
                <div className="ProgressBarBase">
                    <div className="valueBar" style={style} />
                </div>
            </div>
        )
    }
}

export default ProgressBar
